import AutomationToolBenefitsDesktop from "@components/AutomationToolBenefitsDesktop";
import AutomationToolBenefitsMobile, { AutomationToolBenefitsProps } from "@components/AutomationToolBenefitsMobile";
import PaymentProcessCard, { PaymentSectionDataProps } from "@components/integration/PaymentProcessCard";
import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordion";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "",
    title: "Drive more conversions using Click-to-WhatsApp Ads Software",
    description: "Make your ads more engaging, and deliver better impact by redirecting your prospects to your WhatsApp Business using CTWA Ads through Gallabox",
    primaryButtonText: "Start Free Trial",
    imageUrl: "https://assets.gallabox.com/gb-home/ctwa/ctwa-hero-image.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Build customer engagement workflows in minutes",
    subtitle2: "Use Gallabox to create automated customer engagement workflows, and drive more qualified leads down the funnel. With Gallabox, you can:",
    imageUrl: "https://assets.gallabox.com/gb-home/ctwa/customer-engagement.png",
    featureInfoList: [
        "Build your own automated chatbots in minutes",
        "Deploy industry-specific templates based on your ads",
        "Boost engagement rates and push more qualified leads.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Make qualification and lead handoff effortless",
    subtitle2:
        "Let your automated chatbot handle lead qualification, and pass off the interested prospects to your sales agents. With Gallabox’s Shared Team Inbox, businesses can:",
    imageUrl: "https://assets.gallabox.com/gb-home/ctwa/lead-handoff.png",
    featureInfoList: ["Set condition-based contact assignment", "Save time on lead qualification", "Increase pipeline velocity and book demos faster."],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Create a frictionless sales cycle",
    subtitle2: "Let AI agents take care of prospect objections, and make decision making easier. With Gallabox’s conversational AI, businesses can:",
    imageUrl: "https://assets.gallabox.com/gb-home/ctwa/sales-cycle.png",
    featureInfoList: ["Set up 24/7 chatbots that handle user queries", "Segment users to drive better nurturing", "Refine user engagement and give personalized suggestions."],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Integrate with all your office tools",
    subtitle2: "Build a seamless ecosystem of interconnected solutions, with data that stays true across the organization.",
    imageUrl: "https://assets.gallabox.com/gb-home/ctwa/integrate.png",
    featureInfoList: [
        "Push your data into your favourite CRM, ERP, eCommerce platform, and appointment scheduling tools",
        "Have a real-time, centralized source of truth",
        "Run webhooks and APIs that connect with your in-house tools.",
    ],
};

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/ctwa/itees-eye-hospital.png",
        chiptitle: "HEALTHCARE",
        title: "Improving Patient Experience at ITEES Eye Hospital: A Gallabox Success Story",
        statsInfoData: [
            { percentage: "70%", label: "Growth employee productivity" },
            { percentage: "500%", label: "Growth in Patient Footfall" },
            { percentage: "54%", label: "Improved Return Visits" },
        ],
        url: "/case-study/itees",
    },
];

const faqData: FAQSectionProps = {
    title: "FAQs about Click to WhatsApp Ads Software",
    faqItems: [
        {
            question: "Can I target specific audiences with Click to WhatsApp Ads Software?",
            answer: "Yes. All you have to do is set up the campaign in your Facebook Ads Manager to define the target audience and their demographics. In the campaign, you need to choose Messaging Apps as your conversion location and Click to message as the ad type. And on Gallabox’s CTWA software, you can set up auto-replies and chatbots for the incoming click to chat message from ads.",
        },
        {
            question: "Can I track the performance of my Click to WhatsApp Ads campaigns?",
            answer: "Yes, you can. Gallabox’s CTWA solution has a dedicated Click to WhatsApp dashboard to track everything from message open rates to response times and the source URLs of the ads.",
        },
        {
            question: "Does Click to WhatsApp Ads Software support both text and multimedia messages?",
            answer: "Yes, you can respond to Click to WhatsApp messages with text, images, videos, documents, voice – whatever tells your story best. Gallabox’s CTWA builder also let’s you add them to automated chatbot responses.",
        },
        {
            question: "Can I use Click to WhatsApp Ads Software to automate responses to incoming messages?",
            answer: "Of course. Gallabox’s CTWA tool lets you set up smart auto-replies that feel genuinely human while your leads land on an ad and enter your WhatsApp chat. Not just that, you can configure elaborate conversation flows with our AI chatbots and rule-based bot builders.",
        },
        {
            question: "How secure is the data from customers who interact with my Click to WhatsApp Ads?",
            answer: "All conversations that come into the Click to WhatsApp Ads software are encrypted end-to-end. As Meta’s official partner, we follow the same strict security standards that WhatsApp Business API promises and even more.",
        },
        {
            question: "Can I segment leads and create targeted campaigns with Click to WhatsApp Ads Software?",
            answer: "Yes, you can break down your audience into meaningful segments based on their behaviors, custom tags, or CRM properties, or their buyer stage, to name a few.",
        },
        {
            question: "Can I integrate Click to WhatsApp Ads Software with my CRM or other customer engagement tools?",
            answer: "Yes, Gallabox’s Click to WhatsApp Ads provider seamlessly integrates with popular CRMs like Zoho, HubSpot, Odoo, and LeadSquared. These are two-way integrations that ensure complete context sharing between the CTWA provider and the integrations.",
        },
    ],
};

const paymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/ctwa/get-gallabox.png",
        title: "Get Gallabox",
        description: "Sign up for a free trial with Gallabox. Connect your WhatsApp business number and your business details to get started with a free account.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/ctwa/select-template.png",
        title: "Select a template",
        description: "Use one of our tried and tested pre-built WhatsApp flows templates, or build one from scratch. Deploy your templates in a single click.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/ctwa/configure-your-meta-ads.png",
        title: "Configure your Meta ads",
        description: "Set up your Meta ads to enable “Message destinations” and add your WhatsApp Business number. Now just sit back and let Gallabox do the rest.",
    },
];

const defaultFAQData: PaymentProcess = {
    title: "How to get started with Click-to-WhatsApp Ads Software",
    ProcessSteps: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/get-gallabox.png",
            title: "Get Gallabox",
            description: "Sign up for a free trial with Gallabox. Connect your WhatsApp business number and your business details to get started with a free account.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/select-template.png",
            title: "Select a template",
            description: "Use one of our tried and tested pre-built WhatsApp flows templates, or build one from scratch. Deploy your templates in a single click.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/configure-your-meta-ads.png",
            title: "Configure your Meta ads",
            description: "Set up your Meta ads to enable “Message destinations” and add your WhatsApp Business number. Now just sit back and let Gallabox do the rest.",
        },
    ],
};

const automationToolBenefitsData: AutomationToolBenefitsProps = {
    title: "Benefits of using Click-to-WhatsApp Ads Software",
    ProcessSteps: [
        {
            title: "Qualify more leads, faster",
            description:
                "Sending a personalised welcome message can leave a lasting impression on a user’s mind. Set up fun messages with images or videos whenever a customer joins.",
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/qualify-more-leads.png",
        },
        {
            title: "Close more deals",
            description:
                "Whether it’s scheduling a home repair service or helping users reserve a table at a restaurant, enable WhatsApp payments to make sales cycles shorter, and money flowing faster",
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/close-more-deals.png",
        },
        {
            title: "Collect post-sales reviews and feedback",
            description:
                "Set up limited-time offers for previously browsed products and abandoned cart reminders. A simple message can convert a ready-to-buy customer into a buyer!",
            imageUrl: "https://assets.gallabox.com/gb-home/ctwa/reviews-and-feedback.png",
        },
    ],
};

const ClickToWhatsappAds: React.FC = () => {
    return (
        <NewLayout
            description="Integrate WhatsApp Business API with your meta ads to drive better engagement and more conversions using Gallabox CTWA software"
            title="Best Click-to-WhatsApp Ads Software - Gallabox"
            canonical="https://gallabox.com/click-to-whatsapp-ads"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ctwa/ctwa-og.png" }}
            schema={{
                heroOrOgImageAlt: "click-to-whatsapp-ads-image",
                heroOrOgImageDescription: "Drive more conversions using Click-to-WhatsApp Ads Software",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/ctwa/ctwa-hero-image.png",
                softwareFeatureName: "click-to-whatsapp-ads",
                faq: faqData.faqItems,
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} mt-10 mb-20`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>

            <h2 className="md:text-6xl text-4xl font-semibold text-left pb-10 max-w-7xl mx-auto" style={{ fontFamily: "Degular Display" }}>
                Key features and functionalities of Click-to-WhatsApp Ads Software
            </h2>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} removeDivider />

            <AutomationToolBenefitsDesktop automationToolBenefits={automationToolBenefitsData} />

            <AutomationToolBenefitsMobile automationToolBenefits={automationToolBenefitsData} />

            <PaymentProcessCard title="How to get started with Click-to-WhatsApp Ads Software" paymentSectionData={paymentSectionData} backgroundColor="white" />

            <PaymentStepsAccordion paymentStepsData={defaultFAQData} />

            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <FAQSection faqData={faqData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Integrate WhatsApp with your Facebook Ads today" primaryButtonText="Get Free Trial" />
        </NewLayout>
    );
};

export default ClickToWhatsappAds;
